import { mutateUser } from '../graphql-client.js';

export type Upload = {
  uploadUrl: string;
  asset: {
    _id: string;
    _version: number;
    filename: string;
  };
};

export type UploadFile = {
  file: File;
} & Upload;

const UPLOAD_ASSETS_MUTATION = /* GraphQL */ `
mutation ($files: [TSFile]!) {
    uploadAssets(files: $files) {
      uploadUrl
      asset {
        _id
        _version
        filename
      }
    }
  }
`;

const REPLACE_ASSET_MUTATION = /* GraphQL */ `
  mutation ($id: ID!, $version: Int! $file: TSFile!) {
    replaceAsset(_id: $id, _version: $version, file: $file) {
      uploadUrl
      asset {
        _id
        _version
        filename
      }
    }
  }
`;

export async function getUploadUrls(files: File[]): Promise<UploadFile[]> {
  const res = await mutateUser(UPLOAD_ASSETS_MUTATION)({
    files: files.map(({ name, type }) => ({ name, type }))
  });

  return res.uploadAssets.map((upload: Upload, i: number): UploadFile => ({ file: files[i], ...upload }));
}

export async function getReplacementUploadUrl(id: string, version: number, file: File): Promise<UploadFile> {
  const res = await mutateUser(REPLACE_ASSET_MUTATION)({
    id,
    version,
    file: { name: file.name, type: file.type }
  });
  return { file, ...res.replaceAsset };
}
